import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../redux";
import {
  fetchApprovalExpenseListAsync,
  fetchCatApprovalExpenseListAsync,
  handleDynamicApprovalAsync,
  IExpense,
  IGroupedApprovalExpense,
} from "../../../redux/expenseModule";
import { useDateFilter } from "../../../components/Table/hooks/useDateFilter";
import { useDispatchWrapper, useLoggedInUserInfo } from "../../../hooks";
import { ITableCommandBarProps } from "../../../components/Table/components/TableComandBar/interfaces/ITableCommandBarProps";
import { CustomSelect } from "../../../components/formsComponents";
import {
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  MenuItem,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { DateFilterDropdown } from "../../../components/Table/components/DateFilterDropdown/DateFilterDropdown";
import { CustomDatePicker } from "../../../components/formsComponents/CustomDatePicker";
import moment from "moment";
import {
  CSVExportPlugin,
  RefreshPlugin,
  SearchPlugin,
} from "../../../components/Table/plugins";
import { LoadState, MODULE_IDS } from "../../../constants/enums";
import { TableCommandBar } from "../../../components/Table/components/TableComandBar/TableCommandBar";
import { TableSkeleton } from "../../../components/TableSkeleton";
import { useNavigate } from "react-router-dom";
import { TablePaginationActions } from "../../../components/Table/TablePaginationActions";
import { CustomLink } from "../../../components/CustomLink/CustomLink";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { StandardTableActions } from "../../../components/StandardTableActions/StandardTableActions";
import { ButtonWithRemark } from "../../approval/components/ButtonWithRemark";
import { StatusRenderer } from "../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { IBreadcrumbProps } from "../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import { PageContainer } from "../../../components/container/PageContainer";
import { Breadcrumb } from "../../../layout/fullLayout/breadcrumb/Breadcrumb";
import { StandardCard } from "../../../components/Cards";
import { TabsList } from "../../../components/Tabs/TabsList";
import { TabPanel } from "../../../components/Tabs/TabPanel";
import { ApprovalHistoryList } from "../components/ApprovalHistory";
import { useBillingCompanyContext } from "../../../providers";
import { fCurrencyInr } from "../../../helpers/currenySeparators";
import { TableHeaderCell, TableRowCell } from "../../../components/Table";
import { fDate, fDateTime } from "../../../helpers";
import { EnrStatusChip } from "../../../components/EnrStatusChip";
import { app_navbar_routes } from "../../../constants/app-navbar-routes";

export const CategoryApprovalExpenses: React.FC = () => {
  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "Dashboard",
    },
    {
      title: "Expense",
    },
  ];
  const { list, loading, totalRecords } = useSelector(
    (storeState: IStoreState) =>
      storeState.expenseModule.expenseCatApprovalList,
  );
  const {
    first_name,
    last_name,
    role_name,
    role_value,
    role_group,
    user_uuid,
  } = useLoggedInUserInfo();

  const [status, setStatus] = React.useState<IExpense["status"] | "-1">("-1");
  const [searchColumns, setSearchColumns] = React.useState<string[]>([
    "project_name",
  ]);
  const [search, setSearch] = React.useState<string>("");
  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: 25,
  });
  const [pagination, setPagination] = React.useState({
    pageNumber: 1,
    rowsPerPage: 10,
  });
  const { date, type, handleDateSelectChange, dateDropdownList, setDate } =
    useDateFilter({ defaultType: "last28Days" });
  const [expenseTypeValue, setExpenseTypeValue] = React.useState("EXPENSE");
  const [requiredForMeOnly, setRequiredForMeOnly] =
    React.useState<boolean>(false);

  const dispatch = useDispatchWrapper();
  const [tab, setTab] = React.useState(0);

  const billingComponyUuid = useBillingCompanyContext();

  console.log(expenseTypeValue, "expenseTypeValue");

  // handle click toggle button
  const handleChangeToggleButton = (
    event: React.MouseEvent<HTMLElement>,
    value: string,
  ) => {
    setExpenseTypeValue(value);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const tableCommandBarProps: ITableCommandBarProps = {
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          // {
          //   key: "status",
          //   onRender: () => (
          //     <CustomSelect
          //       sx={{ minWidth: "120px" }}
          //       value={status}
          //       onChange={(e: any) =>
          //         setStatus(e.target.value as IExpense["status"])
          //       }
          //     >
          //       <MenuItem value="-1">All Status</MenuItem>
          //     </CustomSelect>
          //   ),
          // },
          {
            key: "byDate",
            onRender: () => (
              <DateFilterDropdown
                value={type}
                options={dateDropdownList}
                onChange={handleDateSelectChange}
              />
            ),
          },
          {
            key: "fromDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "150px" }}
                  value={date.fromDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, fromDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "toDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "150px" }}
                  value={date.toDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, toDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "expense_type",
            onRender: (columns, items) => (
              <ToggleButtonGroup
                color="primary"
                value={expenseTypeValue}
                exclusive
                onChange={handleChangeToggleButton}
                aria-label="expense-type"
                size="small"
              >
                <ToggleButton value="EXPENSE">Expense</ToggleButton>
                {/* <ToggleButton value="JOB">Job</ToggleButton> */}
                <ToggleButton value="ADVANCE">Imprest</ToggleButton>
                <ToggleButton value="VENDOR_PAYMENT">VENDOR</ToggleButton>
              </ToggleButtonGroup>
            ),
          },
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVExportPlugin
                columns={columns}
                items={items}
                filePrefixName="Report"
              />
            ),
          },
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchList} />,
          },
        ],
      },
      rightItems: {
        plugins: {},
        customPlugins: [
          {
            key: "search",
            onRender: () => {
              return (
                <SearchPlugin
                  selectedDropdownValue={searchColumns}
                  dropdownOptions={[
                    { label: "Project Name", value: "project_name" },
                    { label: "Created By", value: "created_by_name" },
                    { label: "Category", value: "expense_category_name" },

                    { label: "Expense Type", value: "expense_type" },
                  ]}
                  onDropdownChange={(value) => setSearchColumns(value)}
                  onChange={(newValue) => {
                    setSearch(newValue);
                  }}
                />
              );
            },
          },
        ],
      },
    },
    columns: [],
    items: [],
  };

  const fetchList = () => {
    dispatch(
      fetchCatApprovalExpenseListAsync(
        {
          status: "REQUESTED",
          page: pagination.pageNumber,
          rowsPerPage: pagination.rowsPerPage,
          columns: searchColumns,
          value: search,
          fromDate: date.fromDate,
          toDate: date.toDate,
        },
        expenseTypeValue,
        requiredForMeOnly,
        billingComponyUuid.comapny.customer_uuid || "",
      ),
    );
  };

  React.useEffect(() => {
    fetchList();
  }, [
    tablePagination,
    date,
    status,
    tab,
    search,
    date,
    expenseTypeValue,
    requiredForMeOnly,
  ]);

  const handlePageChange = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    setTablePagination({ ...tablePagination, pageNumber: newPage + 1 });
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const rowsPerPage = parseInt(event.target.value, 10);

    setTablePagination({
      ...tablePagination,
      rowsInPerPage:
        rowsPerPage === -1 ? totalRecords || list.length : rowsPerPage,
    });
  };

  const isCurrentUserAdmin = ["ADMIN", "SUPERADMIN", "CEO"].includes(
    role_value,
  );

  const handleApprovalSuccess = () => {
    fetchList();
  };
  return (
    <PageContainer title="View Expense" description="this is inner page">
      <Breadcrumb title="View Expense" items={BCrumb} />
      {/* <TabsList
        sx={{ mb: 2, mr: 2 }}
        varaint="fullWidth"
        selectedTab={tab}
        tabs={[{ label: " Approval Expense List" }]}
        onChange={handleTabChange}
      />
      <TabPanel value={tab} index={0}>
      
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <ApprovalHistoryList />
      </TabPanel> */}

      <StandardCard
        heading={
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="h2" fontWeight={"700"}>
              {" "}
              {"Approval Expense List"}
            </Typography>
            {/* {isCurrentUserAdmin && <>
              <Switch checked={requiredForMeOnly} onChange={(evt, checked) => setRequiredForMeOnly(checked)} />
              <Typography variant="h6" fontWeight={"700"}> {"Required From Me"}</Typography>
            </>} */}
          </Box>
        }
      >
        <TableCommandBar {...tableCommandBarProps} />
        <Card
          className="tableScroll"
          sx={{
            borderRadius: "5px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 3px",
            border: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            padding: 0,
            marginTop: 0,
          }}
        >
          <CardContent sx={{ padding: "0px !important" }}>
            <Box
              sx={{
                overflowY: "auto",
                overflowX: "auto",
              }}
            >
              <Table
                aria-label="collapsible table"
                sx={{
                  whiteSpace: {
                    xs: "nowrap",
                    sm: "unset",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableHeaderCell />
                    {expenseTypeValue === "EXPENSE" && (
                      <TableHeaderCell>
                        <Typography variant="h6" fontWeight={"600"}>
                          User
                        </Typography>
                      </TableHeaderCell>
                    )}
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={"600"}>
                        Project Name
                      </Typography>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={"600"}>
                        Total Count
                      </Typography>
                    </TableHeaderCell>
                    {expenseTypeValue === "ADVANCE" && (
                      <TableHeaderCell sx={{ textAlign: "right" }}>
                        <Typography variant="h6" fontWeight={600}>
                          Advance Amount
                        </Typography>
                      </TableHeaderCell>
                    )}
                    {expenseTypeValue === "EXPENSE" && (
                      <TableHeaderCell sx={{ textAlign: "right" }}>
                        <Typography variant="h6" fontWeight={600}>
                          Reimbursed Amount
                        </Typography>
                      </TableHeaderCell>
                    )}

                    {expenseTypeValue === "VENDOR_PAYMENT" && (
                      <>
                        <TableHeaderCell sx={{ textAlign: "right" }}>
                          <Typography variant="h6" fontWeight={600}>
                            Advance To Vendor
                          </Typography>
                        </TableHeaderCell>
                        <TableHeaderCell sx={{ textAlign: "right" }}>
                          <Typography variant="h6" fontWeight={600}>
                            Payable to Vendor
                          </Typography>
                        </TableHeaderCell>
                      </>
                    )}
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={"600"}>
                        Date
                      </Typography>
                    </TableHeaderCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading === LoadState.InProgress ? (
                    <TableSkeleton
                      numberOfCells={expenseTypeValue === "ADVANCE" ? 5 : 6}
                      numberOfRows={5}
                    />
                  ) : (
                    list.map((data) => (
                      <Row
                        key={data.approval_uuid}
                        data={data}
                        expenseTypeValue={expenseTypeValue}
                        onApprovalSuccess={handleApprovalSuccess}
                      />
                    ))
                  )}
                </TableBody>
              </Table>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                    sx={{ borderBottom: 0 }}
                    //colSpan={columns.length + 1}
                    count={totalRecords}
                    rowsPerPage={tablePagination.rowsInPerPage}
                    page={tablePagination.pageNumber - 1}
                    SelectProps={{
                      native: true,
                    }}
                    labelDisplayedRows={(data) => {
                      return (
                        <>
                          {data.from}-{data.to}
                        </>
                      );
                    }}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Box>
          </CardContent>
        </Card>
      </StandardCard>
    </PageContainer>
  );
};

function Row(props: {
  data: IGroupedApprovalExpense;
  expenseTypeValue: string;
  onApprovalSuccess: () => void;
}) {
  const { data, expenseTypeValue, onApprovalSuccess } = props;
  const navigate = useNavigate();
  const dispatch = useDispatchWrapper();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const renderLink = (row: IExpense, value: string | number) => {
    return (
      <CustomLink
        to={`/expense/manage/${row.expense_uuid}`}
        label={value.toString()}
      />
    );
  };

  const handleDynamicApprovalAction = (
    approvalType: "ROLLBACK" | "APPROVED" | "REJECTED",
    remark: string,
    values: IExpense,
  ) => {
    dispatch(
      handleDynamicApprovalAsync(
        {
          dynamic_approval_uuid: values.dynamic_approval_uuid || "",
          remark: remark,
          status: approvalType,
        },
        (isSuccess) => {
          if (isSuccess) {
            onApprovalSuccess();
          } else {
            console.error("Approval failed");
          }
        },
      ),
    );
  };

  const totals = data.childs.reduce(
    (acc, item) => {
      return {
        advanceAmount:
          acc.advanceAmount + Number(item.requested_advance_amount || 0),
        reimbursedAmount:
          acc.reimbursedAmount + Number(item.reimbursed_amount || 0),
      };
    },
    { advanceAmount: 0, reimbursedAmount: 0 },
  );

  const vendor_totals = data.childs.reduce(
    (acc, item) => {
      return {
        advance: acc.advance + Number(item.vendor_advance_amount || 0),
        payment: acc.payment + Number(item.net_vendor_payable_amount || 0),
      };
    },
    { advance: 0, payment: 0 },
  );

  return (
    <>
      <TableRow
        sx={
          open
            ? {
                background: (theme) =>
                  `${
                    theme.palette.mode === "dark"
                      ? theme.palette.grey.A200
                      : theme.palette.grey[100]
                  }`,
              }
            : null
        }
      >
        <TableRowCell
          sx={{
            borderBottom: "0",
          }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableRowCell>
        {expenseTypeValue === "EXPENSE" && (
          <TableRowCell
            sx={{
              borderBottom: "0",
            }}
          >
            <Typography
              color="primary"
              variant="h6"
              onClick={() => setOpen(!open)}
              sx={{ cursor: "pointer" }}
            >
              {data.user_name}
            </Typography>
          </TableRowCell>
        )}

        <TableRowCell
          sx={{
            borderBottom: "0",
          }}
        >
          <Typography
            color="primary"
            variant="h6"
            onClick={() => setOpen(!open)}
            sx={{ cursor: "pointer" }}
          >
            {data.project_name}
          </Typography>
        </TableRowCell>
        <TableRowCell sx={{ borderBottom: "0" }}>
          <Typography variant="body1"> {data.childs.length}</Typography>
        </TableRowCell>
        {(expenseTypeValue === "ADVANCE" || expenseTypeValue === "EXPENSE") && (
          <TableRowCell sx={{ borderBottom: "0", textAlign: "right" }}>
            <Typography variant="h6" fontWeight={600}>
              {fCurrencyInr(totals.advanceAmount + totals.reimbursedAmount)}
            </Typography>
          </TableRowCell>
        )}

        {expenseTypeValue === "VENDOR_PAYMENT" && (
          <>
            <TableRowCell sx={{ borderBottom: "0", textAlign: "right" }}>
              <Typography variant="h6" fontWeight={600}>
                {fCurrencyInr(vendor_totals.advance)}
              </Typography>
            </TableRowCell>
            <TableRowCell sx={{ borderBottom: "0" }}>
              <Typography variant="h6" fontWeight={600}>
                {fCurrencyInr(vendor_totals.payment)}
              </Typography>
            </TableRowCell>
          </>
        )}
        <TableRowCell
          sx={{
            borderBottom: "0",
          }}
        >
          <Typography variant="body1" fontWeight={600}>
            {fDate(data.expense_date || "")}
          </Typography>
        </TableRowCell>
      </TableRow>
      <TableRow>
        <TableRowCell colSpan={13}>
          <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
            sx={{
              background: (theme) =>
                `${
                  theme.palette.mode === "dark"
                    ? theme.palette.grey.A200
                    : theme.palette.grey[100]
                }`,
            }}
          >
            <Box marginBottom={5} marginTop={0}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Actions
                      </Typography>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Project Name
                      </Typography>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Expense Type
                      </Typography>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Created By
                      </Typography>
                    </TableHeaderCell>
                    {expenseTypeValue === "ADVANCE" && (
                      <TableHeaderCell sx={{ textAlign: "right" }}>
                        <Typography variant="h6" fontWeight={600}>
                          Advance Amount
                        </Typography>
                      </TableHeaderCell>
                    )}
                    {expenseTypeValue === "EXPENSE" && (
                      <TableHeaderCell sx={{ textAlign: "right" }}>
                        <Typography variant="h6" fontWeight={600}>
                          Reimbursed Amount
                        </Typography>
                      </TableHeaderCell>
                    )}

                    {expenseTypeValue === "VENDOR_PAYMENT" && (
                      <>
                        <TableHeaderCell sx={{ textAlign: "right" }}>
                          <Typography variant="h6" fontWeight={600}>
                            Advance To Vendor
                          </Typography>
                        </TableHeaderCell>
                        <TableHeaderCell sx={{ textAlign: "right" }}>
                          <Typography variant="h6" fontWeight={600}>
                            Payable to Vendor
                          </Typography>
                        </TableHeaderCell>
                        <TableHeaderCell>
                          <Typography variant="h6" fontWeight={600}>
                            Payable to Vendor (Net of Advances)
                          </Typography>
                        </TableHeaderCell>
                      </>
                    )}

                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Category
                      </Typography>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Expense Date
                      </Typography>
                    </TableHeaderCell>
                    <TableHeaderCell>
                      <Typography variant="h6" fontWeight={600}>
                        Status
                      </Typography>
                    </TableHeaderCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.childs.map((item) => {
                    return (
                      <TableRow key={item.business_purpose}>
                        <TableRowCell sx={{ borderBottom: 0 }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="start"
                            spacing={1}
                          >
                            <StandardTableActions
                              onEditClick={() => {
                                navigate(
                                  expenseTypeValue === "EXPENSE"
                                    ? `/expense/manage/${item.expense_uuid}`
                                    : expenseTypeValue === "ADVANCE"
                                      ? `/advcance-expenses/manage/${item.expense_uuid}`
                                      : `/expense/vendor-payments/edit/${item.expense_uuid}`,
                                );
                              }}
                            />
                            {item.is_user_approver === false ? (
                              <ButtonWithRemark
                                disabled={false}
                                confirmButtonText="Rollback"
                                onConfirm={(remark) =>
                                  handleDynamicApprovalAction(
                                    "ROLLBACK",
                                    remark,
                                    item,
                                  )
                                }
                              />
                            ) : (
                              <>
                                <ButtonWithRemark
                                  disabled={false}
                                  confirmButtonText="Approve"
                                  onConfirm={(remark) =>
                                    handleDynamicApprovalAction(
                                      "APPROVED",
                                      remark,
                                      item,
                                    )
                                  }
                                />
                                <ButtonWithRemark
                                  disabled={false}
                                  confirmButtonText="Reject"
                                  onConfirm={(remark) =>
                                    handleDynamicApprovalAction(
                                      "REJECTED",
                                      remark,
                                      item,
                                    )
                                  }
                                />
                              </>
                            )}
                          </Stack>
                        </TableRowCell>
                        <TableRowCell
                          sx={{
                            borderBottom: "0",
                          }}
                        >
                          {renderLink(item, item.project_name || "--")}
                        </TableRowCell>
                        <TableRowCell
                          sx={{
                            borderBottom: "0",
                          }}
                        >
                          <EnrStatusChip content={item.expense_type} />
                        </TableRowCell>
                        <TableRowCell
                          sx={{
                            borderBottom: "0",
                          }}
                        >
                          <EnrStatusChip content={item.created_by_name} />
                        </TableRowCell>

                        {expenseTypeValue === "EXPENSE" && (
                          <TableRowCell sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                              {fCurrencyInr(item.reimbursed_amount)}
                            </Typography>
                          </TableRowCell>
                        )}
                        {expenseTypeValue === "ADVANCE" && (
                          <TableRowCell
                            sx={{
                              borderBottom: "0",
                              textAlign: "right",
                            }}
                          >
                            <Typography variant="body1">
                              {fCurrencyInr(item.requested_advance_amount)}
                            </Typography>
                          </TableRowCell>
                        )}

                        {expenseTypeValue === "VENDOR_PAYMENT" && (
                          <>
                            <TableRowCell
                              sx={{
                                borderBottom: "0",
                                textAlign: "right",
                              }}
                            >
                              <Typography variant="body1">
                                {fCurrencyInr(item.vendor_advance_amount)}
                              </Typography>
                            </TableRowCell>
                            <TableRowCell
                              sx={{
                                borderBottom: "0",
                                textAlign: "right",
                              }}
                            >
                              <Typography variant="body1">
                                {fCurrencyInr(item.vendor_payable_amount)}
                              </Typography>
                            </TableRowCell>
                            <TableRowCell
                              sx={{
                                borderBottom: "0",
                                textAlign: "right",
                              }}
                            >
                              <Typography variant="h6" fontWeight={600}>
                                {fCurrencyInr(item.net_vendor_payable_amount)}
                              </Typography>
                            </TableRowCell>
                          </>
                        )}
                        <TableRowCell
                          sx={{
                            borderBottom: "0",
                          }}
                        >
                          <Typography variant="body1">
                            {item.expense_category_name}
                          </Typography>
                        </TableRowCell>
                        <TableRowCell
                          sx={{
                            borderBottom: "0",
                          }}
                        >
                          <Typography variant="body1">
                            {fDate(item.expense_date)}
                          </Typography>
                        </TableRowCell>
                        <TableRowCell
                          sx={{
                            borderBottom: "0",
                          }}
                        >
                          <StatusRenderer status={item.status} />
                        </TableRowCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableRowCell>
      </TableRow>
    </>
  );
}
